/* COMMENTED FOR DIAS CUSTOMIZATION
export type ViewType<T extends string = ''> = T | ('grid' | 'list');port type ViewType<T extends string = ''> = T | ('grid' | 'grid-2' | 'grid-3' | 'grid-4' | 'grid-5' | 'list');
 */

export type DeviceType<T extends string = ''> = T | ('mobile' | 'tablet' | 'desktop');

export const headerTypes = <const>['simple', 'error', 'checkout'];

export type HeaderType = (typeof headerTypes)[number];
/* DIAS CUSTOMIZATION STARTS */
export type ViewType<T extends string = ''> = T | ('grid' | 'grid-2' | 'grid-3' | 'grid-4' | 'grid-5' | 'list');
/* DIAS CUSTOMIZATION ENDS */
